import React from 'react';
import { MapImg1} from '../../Constant/Index';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';

const ContactUs = () => {
    let theAddress = "2760 EAST EL PRESIDIO ST CARSON, CA 90810";
    let TheEmail = "Lax@webtransusa.com";
    let TheNumber = "(310) 522 6666";
    let ThePosition = "Branch"
    let Bracnches = [
        {
            BranchName: "Los Angeles, CA",
            BranchPosition: "Headquarter",
            BranchAddress: theAddress,
            BranchEmail: TheEmail,
            BrancNo: TheEmail
        },
        {
            BranchName: "New York, Ny",
            BranchPosition: ThePosition,
            BranchAddress: theAddress,
            BranchEmail: TheEmail,
            BrancNo: TheEmail
        },
        {
            BranchName: "Chicago, Il",
            BranchPosition: ThePosition,
            BranchAddress: theAddress,
            BranchEmail: TheEmail,
            BrancNo: TheEmail
        },
        {
            BranchName: "Atlanta, Ga",
            BranchPosition: ThePosition,
            BranchAddress: theAddress,
            BranchEmail: TheEmail,
            BrancNo: TheEmail
        },
        {
            BranchName: "San Francisco, Ca",
            BranchPosition: ThePosition,
            BranchAddress: theAddress,
            BranchEmail: TheEmail,
            BrancNo: TheEmail
        }
    ]
    return (
        <>
            <Header />
            {/* Contact Section start Here */}
            <section className="index-contact-section contact-page">
                <div className="container">
                    <div className="contact-start">
                        <div className="top-heading main text-center">
                            <h2 className="lg-heading mb-5 mt-5">Contact Us</h2>
                        </div>
                        <div className="row">
                            <div className="col-xxl-4 col-xl-5 col-lg-5 col-md-5">
                                <h5 className="sm-heading captalize-text">our contact details</h5>
                                <div className="contact-details">
                                    <div className="top-text">
                                        {
                                            Bracnches.map((Branch, index) => (
                                                <>
                                                    <div className="sinlge-branch mb-4 pb-2" kery={index}>

                                                        <div className="current-hq">
                                                            <h3 className="md-text">{Branch.BranchName} <br /><span className='ps-0'>({Branch.BranchPosition})</span></h3>
                                                        </div>
                                                        <ul className="contact-lis">
                                                            <li className='contact-item'><i className="icon fa fa-map-marker"></i><span className='contact-info' >276{Branch.BranchAddress}</span></li>
                                                            <li className='contact-item'><i className="icon fa fa-envelope"></i><a className='contact-info' href={"mailto: " + Branch.BranchEmail}>Email: {Branch.BranchEmail}.com</a></li>
                                                            <li className='contact-item'><i className="icon fa fa-phone"></i><a className='contact-info' href={"tel:" + Branch.BrancNo}>Tel: {Branch.BrancNo}</a></li>
                                                        </ul>
                                                    </div>
                                                </>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-8 col-xl-7 col-lg-7 col-md-7 mt-lg-0 mt-4 d-flex flex-column justify-content-start">
                                <div className="contact-index-form">
                                    <form className='custom-from'>
                                        <h5 className="sm-heading mb-1">Send Message without any hesitation</h5>
                                        <div className="row">
                                            <div className="col-md-6 mt-3">
                                                <div className="form-group">
                                                    <label htmlFor="" className="custom-label">First Name</label>
                                                    <input type="text" className="form-control" name='' id='' placeholder='First Name' />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <div className="form-group">
                                                    <label htmlFor="" className="custom-label">Last Name</label>
                                                    <input type="text" className="form-control" name='' id='' placeholder='Last Name' />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <div className="form-group">
                                                    <label htmlFor="" className="custom-label">Email Address</label>
                                                    <input type="email" className="form-control" name='' id='' placeholder='Email Address' />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <div className="form-group">
                                                    <label htmlFor="" className="custom-label">Contact Number</label>
                                                    <input type="text" className="form-control" name='' id='' placeholder='Contact Number' />
                                                </div>
                                            </div>
                                            <div className="col-md-12 mt-3">
                                                <div className="form-group">
                                                    <label htmlFor="" className="custom-label">Message:</label>
                                                    <textarea className="form-control form-md-control" name='' id='' placeholder='Message' ></textarea>
                                                </div>
                                            </div>
                                            <div className="col-md-12 mt-4">
                                                <button className="btn" type='submit'>Submit</button>
                                            </div>
                                        </div>
                                    </form>
                                    <div className="map-here mt-4">
                                        {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6999584.908037069!2d-105.36941405478338!3d31.060611276577166!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864070360b823249%3A0x16eb1c8f1808de3c!2sTexas%2C%20USA!5e0!3m2!1sen!2s!4v1688547942513!5m2!1sen!2s"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                                        <img src={MapImg1} alt="" width="100%"  />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Contact Section End Here */}
            {/* Footer Included Here */}
            <Footer />
            {/* Footer Included Here */}
        </>
    )
}
export default ContactUs;